import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material"
import { useContext, useEffect, useState } from "react"
import CardComponent from "../../components/card"
import ContainerComponent from "../../components/conatiner"
import HeaderComponent from "../../components/header"
import InputComponent from "../../components/input"
import LoadingComponent from "../../components/loading"
import { ToastErro, ToastSucesso } from "../../components/toast"
import DrawerThemeContext from "../../context/drawerTheme/DrawerThemeContext"
import PrimaryColorContext from "../../context/primaryColor/PrimaryColorContext"
import UserContext from "../../context/user/UserContext"
import { AuthChangePasswordService } from "../../services/auth"

const ProfilePage = () => {

    const { primaryColor, setPrimaryColor } = useContext(PrimaryColorContext);
    const { drawerTheme, setDrawerTheme } = useContext(DrawerThemeContext);

    const [loadingColor, setLoadingColor] = useState<boolean>(true);
    const [loadingDrawer, setLoadingDrawer] = useState<boolean>(false);

    const [loading, setLoading] = useState<boolean>(false);

    // variaveis de alterar a senha
    const [password, setPassword] = useState<string>('');
    const [newPassword, setNewPassword] = useState<string>('');
    const [confNewPassword, setConfNewPassword] = useState<string>('');
    // variaveis de alterar a senha

    const { user } = useContext(UserContext);

    // funcao para converter hexadecimal para rgb
    const hexToRgb = (hex: any) =>
        hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i
            , (m: any, r: any, g: any, b: any) => '#' + r + r + g + g + b + b)
            .substring(1).match(/.{2}/g)
            .map((x: any) => parseInt(x, 16));
    // funcao para converter hexadecimal para rgb    

    // mudar a cor da variavel css
    const changeColor = (value: any) => {
        let root = document.documentElement;
        root.style.setProperty('--bs-primary-rgb', value[0] + ', ' + value[1] + ', ' + value[2]);
    }
    // mudar a cor da variavel css

    // funcao para restuarar cor padrao
    const restoreColor = async () => {

        setLoadingColor(true);

        let root = document.documentElement;
        root.style.setProperty('--bs-primary-rgb', 33 + ', ' + 33 + ', ' + 33);
        await setPrimaryColor("#212121");
        localStorage.setItem("primaryColor", "#212121");

        setLoadingColor(false);
    }
    // funcao para restuarar cor padrao

    // funcao para mudar o tema da drawer
    const changeDrawerTheme = async (value: string) => {
        setLoadingDrawer(true);
        await setDrawerTheme(value);
        localStorage.setItem("drawerTheme", value);
        setLoadingDrawer(false);
    }
    // funcao para mudar o tema da drawer

    // funcao para alterar a senha
    const changePassword = async (e: any) => {

        e.preventDefault();

        var letrasMaiusculas = /[A-Z]/;
        var letrasMinusculas = /[a-z]/;
        var numeros = /[0-9]/;
        var caracteresEspeciais = /[!|@|#|$|%|^|&|*|(|)|-|_]/;

        // verificar se todos os campos foram preenchidos
        if (newPassword.length < 6) {
            ToastErro('A nova senha deve conter no mínimo 6 caracteres!');
            return;
        }
        // verificar se todos os campos foram preenchidos

        // verificar se a senha possui 1 letra maiuscula
        if (!letrasMaiusculas.test(newPassword)) {
            ToastErro('A nova senha deve conter no mínimo 1 letra maiúscula!');
            return;
        }
        // verificar se a senha possui 1 letra maiuscula

        // verificar se a senha possui 1 letra minúscula
        if (!letrasMinusculas.test(newPassword)) {
            ToastErro('A nova senha deve conter no mínimo 1 letra minúscula!');
            return;
        }
        // verificar se a senha possui 1 letra minúscula

        // verificar se a senha possui 1 número
        if (!numeros.test(newPassword)) {
            ToastErro('A nova senha deve conter no mínimo 1 número!');
            return;
        }
        // verificar se a senha possui 1 número

        // verificar se a senha possui 1 caractere especial
        if (!caracteresEspeciais.test(newPassword)) {
            ToastErro('A nova senha deve conter no mínimo 1 caractere especial!');
            return;
        }
        // verificar se a senha possui 1 caractere especial

        // verificar se as senhas são iguais
        if (newPassword !== confNewPassword) {
            ToastErro('As senhas não são iguais!');
            return;
        }
        // verificar se as senhas são iguais

        setLoading(true);

        await AuthChangePasswordService(password, newPassword).then(resp => {

            setPassword('');
            setNewPassword('');
            setConfNewPassword('');
            ToastSucesso(resp.data.message);

        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        setLoading(false);

    }
    // funcao para alterar a senha

    useEffect(() => {
        if (primaryColor) {
            setLoadingColor(false);
        }
    }, [primaryColor])

    return (
        <>
            <HeaderComponent
                title="Perfil"
            />
            <ContainerComponent>
                {
                    loadingColor || loadingDrawer || loading

                        ?

                        <LoadingComponent />

                        :

                        <>
                            <div className="row">
                                <CardComponent
                                    col={12}
                                >
                                    <>
                                        <div className="card-title mb-4">Detalhes da Conta</div>
                                        <div className="row">
                                            <InputComponent
                                                label="ID"
                                                col={2}
                                                defaultValue={user?.id}
                                                disabled
                                            />
                                            <InputComponent
                                                label="Nome"
                                                col={10}
                                                defaultValue={user?.name}
                                                disabled
                                            />
                                        </div>
                                        <div className="row">
                                            <InputComponent
                                                label="Username"
                                                col={6}
                                                defaultValue={user?.username}
                                                disabled
                                            />
                                            <InputComponent
                                                label="E-mail"
                                                col={6}
                                                disabled
                                                type="email"
                                                defaultValue={user?.email}
                                            />
                                        </div>                                       
                                    </>
                                </CardComponent>
                            </div>
                            <div className="row">
                                <div className="col-md-7">
                                    <CardComponent
                                        col={12}
                                    >
                                        <form onSubmit={changePassword}>
                                            <div className="card-title mb-4">Alterar Senha</div>
                                            <div className="row">
                                                <InputComponent
                                                    label="Senha atual"
                                                    col={12}
                                                    type="password"
                                                    defaultValue={password}
                                                    onChange={(e: any) => setPassword(e.target.value)}
                                                    required
                                                />
                                            </div>
                                            <div className="row">
                                                <InputComponent
                                                    label="Nova senha"
                                                    col={12}
                                                    type="password"
                                                    defaultValue={newPassword}
                                                    onChange={(e: any) => setNewPassword(e.target.value)}
                                                    required
                                                />
                                            </div>
                                            <div className="row">
                                                <InputComponent
                                                    label="Confirme a nova senha"
                                                    col={12}
                                                    type="password"
                                                    defaultValue={confNewPassword}
                                                    onChange={(e: any) => setConfNewPassword(e.target.value)}
                                                    required
                                                />
                                            </div>
                                            <div className="d-flex justify-content-end mt-4">
                                                <button className="btn btn-primary" type="submit">Salvar</button>
                                            </div>
                                        </form>
                                    </CardComponent>
                                </div>
                                <div className="col-md-5">
                                    <CardComponent
                                        col={12}
                                    >
                                        <>
                                            <div className="card-title mb-3">
                                                Cor Principal do Sistema
                                            </div>
                                            <div className="row">
                                                <InputComponent
                                                    label="Escolha a cor"
                                                    col={12}
                                                    type="color"
                                                    defaultValue={primaryColor}
                                                    onChange={(e: any) => {
                                                        changeColor(hexToRgb(e.target.value));
                                                        setPrimaryColor(e.target.value);
                                                        localStorage.setItem("primaryColor", e.target.value);
                                                    }}
                                                />
                                            </div>
                                            <div className="d-flex justify-content-end mt-3">
                                                <button className="btn btn-primary" type="button" onClick={restoreColor}>Restaurar</button>
                                            </div>
                                        </>
                                    </CardComponent>

                                    <CardComponent
                                        col={12}
                                    >
                                        <>
                                            <div className="card-title mb-3">
                                                Tema do Menu Lateral
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <FormControl fullWidth>
                                                        <InputLabel>Escolha o Tema</InputLabel>
                                                        <Select
                                                            label="Escolha o Tema"
                                                            defaultValue={drawerTheme}
                                                            onChange={(e: any) => changeDrawerTheme(e.target.value)}
                                                        >
                                                            <MenuItem value={'dark'}>Escuro</MenuItem>
                                                            <MenuItem value={'light'}>Claro</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </div>
                                        </>
                                    </CardComponent>
                                </div>
                            </div>
                        </>
                }
            </ContainerComponent>
        </>
    )

}

export default ProfilePage
